<template>
	<el-dialog
		title="添加人员信息"
		:close-on-click-modal="false"
		:close-on-press-escape="false"
		:visible.sync="dialogVisible"
		append-to-body
		top="8vh"
		:show-close="false"
		@close="closeDialog"
	>
		<div slot="title" class="flex align-center justify-between">
			<div class="flex align-center">
				<span class="el-icon-user text-gray text-lg"></span>
				<div class="margin-left-xs"><div class="text-bold">添加人员信息</div></div>
			</div>
			<el-link :underline="false" type="info" @click="dialogVisible = false"><i class="el-icon-close text-xxl"></i></el-link>
		</div>
		<div style="height: 60vh; overflow: auto;" class="padding">
			<el-form ref="formAdd" :model="formAdd" label-suffix=":" label-width="100px">
				<el-form-item label="姓名" prop="name" :rules="{ required: true, message: '请输入活动名称', trigger: 'blur' }">
					<el-input v-model="formAdd.name" placeholder="身份证上的姓名" style="width: 220px;"></el-input>
				</el-form-item>
				<el-form-item label="性别" prop="gender" :rules="{ required: true, message: '请选择性别', trigger: 'blur' }">
					<el-radio-group v-model="formAdd.gender">
						<el-radio :label="1">男</el-radio>
						<el-radio :label="2">女</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="民族" prop="people" :rules="{ required: true, message: '请输入民族', trigger: 'blur' }">
					<el-select v-model="people" @change="changePeople" placeholder="请选择">
						<el-option label="汉族" value="汉族"></el-option>
						<el-option label="回族" value="回族"></el-option>
						<el-option label="满族" value="满族"></el-option>
						<el-option label="蒙古族" value="蒙古族"></el-option>
						<el-option label="维吾尔族" value="维吾尔族"></el-option>
						<el-option label="藏族" value="藏族"></el-option>
						<el-option label="壮族" value="壮族"></el-option>
						<el-option label="其他" value="其他"></el-option>
					</el-select>
					<el-input v-model="formAdd.people" placeholder="请填写民族" style="width: 220px;" class="margin-left-sm" v-if="peopleInputVisible"></el-input>
				</el-form-item>
				<el-form-item label="籍贯" prop="birthplace" :rules="{ required: true, message: '请输入籍贯', trigger: 'blur' }">
					<cascader-region :deep="2" width="220px" @change="changeRegion"></cascader-region>
				</el-form-item>
				<el-form-item label="婚姻">
					<el-radio-group v-model="formAdd.marriage">
						<el-radio :label="1">已婚</el-radio>
						<el-radio :label="0">未婚</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="身份证号" prop="idcard" :rules="{ required: true, message: '请输入身份证号', trigger: 'blur' }">
					<el-input v-model="formAdd.idcard" placeholder="身份证号码" style="width: 220px;"></el-input>
				</el-form-item>
				<el-form-item label="生日" prop="birthday" :rules="{ required: true, message: '请选择出生日期', trigger: 'blur' }">
					<el-date-picker type="date" value-format="yyyy-MM-dd" placeholder="选择日期" v-model="formAdd.birthday"></el-date-picker>
				</el-form-item>
				<el-form-item label="手机号码" prop="mobile" :rules="{ required: true, message: '请输入手机号码', trigger: 'blur' }">
					<el-input v-model="formAdd.mobile" placeholder="手机号码" style="width: 220px;"></el-input>
				</el-form-item>
				<el-form-item label="微信号码" prop="weixin" :rules="{ required: true, message: '请输入微信号码', trigger: 'blur' }">
					<el-input v-model="formAdd.weixin" placeholder="可以搜索到微信的号码" style="width: 220px;"></el-input>
				</el-form-item>
				<el-form-item label="QQ" prop="qq"><el-input v-model="formAdd.qq" placeholder="QQ号码" style="width: 220px;"></el-input></el-form-item>
				<el-form-item label="邮箱" prop="email"><el-input v-model="formAdd.email" placeholder="QQ号码" style="width: 220px;"></el-input></el-form-item>
				<el-form-item label="住址" prop="address" :rules="{ required: true, message: '请输入现居住住址', trigger: 'blur' }">
					<el-input v-model="formAdd.address" placeholder="现居住地址,精确到具体门牌号" style="width: 80%;"></el-input>
				</el-form-item>
				<el-form-item label="紧急联系人" prop="linkman.name" :rules="{ required: true, message: '请输入联系人姓名', trigger: 'blur' }">
					<el-input v-model="formAdd.linkman.name" placeholder="姓名" style="width: 220px;"></el-input>
				</el-form-item>
				<el-form-item label="" prop="linkman.gx" :rules="{ required: true, message: '请输入关系', trigger: 'blur' }">
					<el-input v-model="formAdd.linkman.gx" placeholder="关系" style="width: 220px;"></el-input>
				</el-form-item>
				<el-form-item label="" prop="linkman.mobile" :rules="{ required: true, message: '请输入手机号码', trigger: 'blur' }">
					<el-input v-model="formAdd.linkman.mobile" placeholder="手机号码" style="width: 220px;"></el-input>
				</el-form-item>
				<el-divider content-position="left">工作信息</el-divider>
				<el-form-item label="所属部门">
					<div v-for="item in departmentData" :key="item.id" style="line-height: 25px;" class="flex align-center">
						<el-breadcrumb separator-class="el-icon-arrow-right" class="padding-bottom-sm">
							<el-breadcrumb-item v-for="(name, idx) in item.pathName" :key="idx">
								<span class="text-grey">{{ name }}</span>
							</el-breadcrumb-item>
						</el-breadcrumb>
					</div>
					<el-popover placement="left" title="选择部门" width="230" trigger="click" @show="departmentSelectVisible = true" @hide="departmentSelectVisible = false">
						<department-select :visible="departmentSelectVisible" :current="formAdd.department" @change="changeDepartment"></department-select>
						<el-button size="small" slot="reference">点击修改</el-button>
					</el-popover>
				</el-form-item>
				<el-form-item label="工号" prop="officeid" :rules="{ required: true, message: '请输入工号', trigger: 'blur' }">
					<el-input v-model="formAdd.officeid" placeholder="工号" style="width: 220px;"></el-input>
				</el-form-item>
				<el-form-item label="职务" prop="position" :rules="{ required: true, message: '请输入职务', trigger: 'blur' }">
					<el-input v-model="formAdd.position" placeholder="职务" style="width: 220px;"></el-input>
				</el-form-item>
				<el-form-item label="是否在职"><el-switch v-model="formAdd.stateflag" :active-value="1" :inactive-value="0"></el-switch></el-form-item>
				<el-form-item label="入职时间" prop="jointime" :rules="{ required: true, message: '请选择入职时间', trigger: 'blur' }">
					<el-date-picker type="date" value-format="yyyy-MM-dd" placeholder="选择日期" v-model="formAdd.jointime"></el-date-picker>
				</el-form-item>
				<el-form-item label="离职时间" prop="leavetime" :rules="{ required: true, message: '请选择离职时间', trigger: 'blur' }" v-if="formAdd.stateflag == 0">
					<el-date-picker type="date" value-format="yyyy-MM-dd" placeholder="选择日期" v-model="formAdd.leavetime"></el-date-picker>
				</el-form-item>
			</el-form>
		</div>
		<div slot="footer" class="text-left padding-left-xl">
			<el-button type="primary" @click="formSubmitAdd()">提交保存</el-button>
			<el-button @click="closeDialog">取 消</el-button>
		</div>
	</el-dialog>
</template>

<script>
import departmentSelect from '@/components/department-select.vue';
import cascaderRegion from '@/components/cascader-region.vue';
export default {
	components: { departmentSelect, cascaderRegion },
	name: 'employee-add',
	props: {
		visible: {
			type: Boolean,
			default: () => {
				return false;
			}
		},
		config: {
			type: Object,
			default: () => {
				return { avatarSize: 128 };
			}
		}
	},
	data() {
		return {
			dialogVisible: false,
			people:"汉族",
			peopleInputVisible:false,
			departmentSelectVisible: false,
			departmentData: [],
			cfg: {},
			formAdd: {
				gender:"",
				people:"汉族",
				marriage:0,
				department: [],
				linkman: {}
			},
			loading: true,
			errorMsg: ''
		};
	},
	created: function() {},
	mounted() {
		this.dialogVisible = this.visible;
		this.cfg = this.config;
	},
	methods: {
		closeDialog() {
			this.dialogVisible = false;
			this.$emit('close', false);
		},
		changePeople(e){
			if(e=='其他'){
				this.formAdd.people="";
				this.peopleInputVisible=true;
			}
			else{
				this.formAdd.people=e;
				this.peopleInputVisible=false;
			}
		},
		changeRegion(e) {
			this.formAdd.birthplace=e;
			console.log(e);
		},
		changeDepartment(selected, data) {
			this.departmentSelected = selected;
			this.departmentData = data;
		},
		formSubmitAdd() {
			this.$refs['formAdd'].validate(valid => {
				if (valid) {
					if (this.departmentAdd.length < 1) {
						this.$alert('请选择部门并设置主部门');
						return false;
					}
					let departmentAdd = [];
					for (let i = 0; i < this.departmentAdd.length; i++) {
						if (this.departmentAdd[i].is_main) {
							this.formAdd.main_department = this.departmentAdd[i].id;
						}
						departmentAdd.push(this.departmentAdd[i].id);
					}
					this.formAdd.department = departmentAdd;
					const loading = this.$loading({
						lock: true,
						text: '处理中...',
						background: 'rgba(0, 0, 0, 0.7)'
					});
					this.$http.post('/server/index.php?m=hr/department&a=addEmp', { data: this.formAdd }).then(
						res => {
							loading.close();
							if (res.result == 'ok') {
								this.$alert('创建人员信息成功！', {
									title: '操作成功',
									type: 'success',
									callback: () => {
										this.$router.back(-1);
									}
								});
							} else {
								this.$alert(res.msg, {
									title: '操作错误',
									type: 'error'
								});
							}
						},
						r => {
							loading.close();
							this.$alert('网络错误，指定的服务无法访问。', {
								title: '系统错误',
								type: 'error'
							});
						}
					);
					return false;
				} else {
					console.log('error submit!!');
					return false;
				}
			});
		}
	},
	watch: {
		visible: function(val) {
			this.dialogVisible = val;
		}
	}
};
</script>

<style>
	.el-dialog__footer{
		border-top: #eee 1px solid;
	}
.infoshow-list {
	display: flex;
	justify-content: space-between;
}
</style>
